import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import {
  GET_ALL_OPERATOR_PRODUCTS,
  CREATE_OPERATOR_PRODUCT,
  UPDATE_OPERATOR_PRODUCT,
  DELETE_OPERATOR_PRODUCT,
} from "./actionTypes"
import {
  getAllOperatorProductsCall,
  createOperatorProductCall,
  updateOperatorProductCall,
  deleteOperatorProductCall,
  API_URL,
} from "../../helpers/repository"
import {
  getAllOperatorProductsResponseSuccess,
  getAllOperatorProducts,
} from "./actions"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"
import { getAllSuppliers } from "store/suppliers/actions"
import { getAllProducts } from "store/products/actions"

function* attemptGetAllOperatorProducts() {
  try {
    const response = yield call(getAllOperatorProductsCall)
    yield put(
      getAllOperatorProductsResponseSuccess(
        response.data.data.operator_products
      )
    )
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateOperatorProduct(action) {
  const { history } = action
  try {
    const response = yield call(createOperatorProductCall, action.payload)
    showMessage("success", response.data.message)
    history.push("/operator-products")
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
  }
}

// -------------------------------------------------------EDIT------------------------------------------------------
function* attemptEditOperatorProduct(action) {
  const { history, redirectTo } = action
  try {
    const response = yield call(updateOperatorProductCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllOperatorProducts())
    yield put(getAllSuppliers())
    yield put(getAllProducts())
    history.push(`/${redirectTo}`)
  } catch (error) {
    showErrorMessages(error)
  }
}

// -------------------------------------------------------DELETE------------------------------------------------------
function* attemptDeleteOperatorProduct(action) {
  try {
    const response = yield call(deleteOperatorProductCall, action.payload)
    showMessage("success", response.data.message)
    yield put(getAllOperatorProducts())
  } catch (error) {
    showErrorMessages(error)
  }
}

function* OperatorProductsSaga() {
  yield takeEvery(GET_ALL_OPERATOR_PRODUCTS, attemptGetAllOperatorProducts)
  yield takeEvery(CREATE_OPERATOR_PRODUCT, attemptCreateOperatorProduct)
  yield takeEvery(UPDATE_OPERATOR_PRODUCT, attemptEditOperatorProduct)
  yield takeEvery(DELETE_OPERATOR_PRODUCT, attemptDeleteOperatorProduct)
}

export default OperatorProductsSaga
